import React, {useState} from "react"

// const i1pic = new URL("../images/i1.jpeg", import.meta.url)
import i1pic from "../images/i1.jpeg"

function Home(){

    const [mytext, setMytext]= useState(1)

    function changetext(){
          setMytext(oldvalue => oldvalue+1) 
    }

     return  <div>
                
                    <h1>Home</h1>
                    <div class="i1pic">
                        <img src= {i1pic} />
                    </div>
                    <section>
                        {/* <p>Please enter a value:</p> */}

                        {/* <input type="text" onChange={afterChange} /> */}
                        <button onClick={changetext}>Click on it</button>
                        <p>{mytext}</p> 
                    </section>
                
            </div>
}

export default Home



// WEBPACK FOOTER //
// ./src/components/home.js